/**
 * Navigation composable for centralized routing logic
 * Provides reusable navigation methods across the application
 */
import { useRouter } from 'vue-router'

export function useNavigation() {
  const router = useRouter()

  /**
   * Navigate to any path
   * @param {string} path - The route path to navigate to
   */
  const navigate = (path) => {
    router.push(path)
  }

  /**
   * Navigate to home/landing page
   */
  const navigateHome = () => {
    navigate('/')
  }

  /**
   * Navigate to "About Us" page
   */
  const navigateToMore = () => {
    navigate('/ueberUns')
  }

  /**
   * Navigate back in history
   */
  const navigateBack = () => {
    router.back()
  }

  return {
    navigate,
    navigateHome,
    navigateToMore,
    navigateBack
  }
}
